import React from 'react';
import DefaultPage from "../components/default-page";

const ErrorPage = () => {
    return (
        <DefaultPage>
            <h1 className="header">This page could not be found</h1>
        </DefaultPage>
    )
}

export default ErrorPage;